export const ceil2 = (n) => Math.ceil(n / 2) * 2;
export const floor2 = (n) => Math.floor(n / 2) * 2;
